<template>
  <span>{{ getProductsCount() }}</span>
</template>

<script>
import get from "lodash/get";
export default {
  name: "InvoicesTableProductsCount",

  methods: {
    getProductsCount() {
      return get(this.data, "n_prods");
    },
  },
};
</script>
